export const NO_PROPOSAL_ALERTS = "noProposalAlerts";